"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactBootstrap = require("react-bootstrap");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function TextArea(_ref) {
  var {
    formik,
    config,
    customContent
  } = _ref;
  var {
    name,
    placeholder
  } = config;
  var placeholderText = placeholder ? placeholder : '';
  var onChangeHandler = e => {
    e.target.value = e.target.value.replace(/[^A-Za-z0-9 ._'$,-]/g, '');
    formik.handleChange(e);
  };
  var showError = formik.errors[name] && formik.touched[name];
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, customContent ? customContent : '', /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    className: "form-group col-sm-12"
  }, /*#__PURE__*/_react.default.createElement("textarea", {
    id: "ccpa-".concat(name),
    className: "form-control ".concat(showError ? 'is-invalid' : ''),
    name: name,
    onChange: onChangeHandler,
    onBlur: formik.handleBlur,
    maxLength: 2000,
    placeholder: placeholderText
  }), showError ? /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'block'
    },
    className: "custom-feedback invalid-feedback"
  }, formik.errors[name]) : ''));
}
var _default = exports.default = TextArea;